import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { TableModule } from 'primeng/table';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import { SubmittedReportCountByPostAndYearResult, ReportFilter, GraphData } from '../../../../models/analytics.model';
import { AnalyticsService } from '../../../../services/analytics.service';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
//import * as Highcharts from "highcharts";
import * as Highcharts from 'highcharts/highmaps';
//import MapModule from 'highcharts/modules/map';
import { Options } from "highcharts";
import exporting from 'highcharts/modules/exporting';
import offline from 'highcharts/modules/offline-exporting';
import HC_more from "highcharts/highcharts-more";
import { NotifierService } from 'angular-notifier';
var mapWorld = require('@highcharts/map-collection/custom/world.geo.json');
// const noData = require('highcharts/modules/no-data-to-display');
// noData(Highcharts);
//MapModule(Highcharts);
HC_more(Highcharts);
exporting(Highcharts);
offline(Highcharts);


@Component({
  selector: 'app-report-submitted-by-post',
  templateUrl: './report-submitted-by-post.component.html',
  styleUrls: ['./report-submitted-by-post.component.css']

})


export class ReportSubmittedByPostComponent implements OnInit,OnChanges {
  reportData:SubmittedReportCountByPostAndYearResult[]=[];
  loading: boolean;
  cols: any[];

  @Input() reportFilters: ReportFilter;
  toggleOptions:SelectItem[]=[];
  selectedOption:SelectItem;
  reportYears: SelectItem[];
  graphReportYears:SelectItem[];
  countries: SelectItem[];
  posts: SelectItem[];
  requiredReportCounts: SelectItem[];
  voluntaryReportCounts: SelectItem[];
  totalReportCounts: SelectItem[];

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "mapChart";

  chartOptions: any;
  selectedYear:SelectItem;
  graphData :GraphData[]=[];

  constructor(private analyticsService:AnalyticsService,
              private lookupAdminService:LookupAdminService,
              private notifier:NotifierService) { }

  ngOnInit() {
    // this.toggleOptions.push({ label: 'Tabular',value:0 });
    // this.toggleOptions.push({ label: 'Graphical',value:1});
  this.toggleOptions = [
    {icon: 'fa fa-2x fa-list-alt', label: 'View in Table',value:0 },
    {icon: 'fa fa-2x fa-bar-chart', label: 'View in Graph',value:1}
];
   this.selectedOption =this.toggleOptions[0];

  }


  ngOnChanges(changes:SimpleChanges)
  {
    if(!changes.firstChange)
    {
     this.LoadReportData();

    }
  }


  private LoadReportData()
  {
    //console.log("submitted report by post");
    //console.log(this.reportFilters);
    this.graphData=[];
    this.analyticsService.getSubmittedReportCountByPostAndYear$(this.reportFilters)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(resp=>{
      if(resp.ok)
      this.reportData = resp.body;
      //console.log(this.reportData);
      this.LoadTableFilters(this.reportData);
      if(this.graphReportYears[0])
      {
        this.LoadChart(this.graphReportYears[0].value);
      }
      else{
        this.LoadChart(this.reportFilters.selectedReportYears[0]);
      }
    },
    error=>{
      this.notifier.notify('error','Error displaying report,please contact Tech Support');
      console.error('Error getting data via subscribe() method:', error);
    });


    this.cols = [
        { field: 'reportYear', header: 'Report Year' },
        { field: 'countryName', header: 'Country' },
        { field: 'postName', header: 'Post' },
        { field: 'requiredReportCount', header: 'Required Report Count' },
        { field: 'voluntaryReportCount', header: 'Voluntary Report Count' },
        { field: 'totalReportCount', header: 'Total Count' }
      ];
  }

  LoadTableFilters(reportData:SubmittedReportCountByPostAndYearResult[]) {
    this.reportYears = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.reportYear));
    this.graphReportYears = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.reportYear));
    this.graphReportYears.sort((a,b)=>{
     if (a.value > b.value) return -1;
     if (a.value < b.value) return 1;
     return 0;

    });
    this.countries = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.countryName));
    this.posts = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.postName));
    this.requiredReportCounts = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.requiredReportCount));
    this.voluntaryReportCounts = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.voluntaryReportCount));
    this.totalReportCounts = this.lookupAdminService.GetUniqueValues(reportData.map(r => r.totalReportCount));
  }

  onReportYearChange(reportYear:number)
  {
     this.graphData=[];
     this.LoadChart(reportYear);
  }

  LoadChart(reportYear:number)
  {
    mapWorld.features.forEach(element => {
      //console.log(element);
      let filter = this.reportData.filter(x=>x.countryName.toLowerCase() == element.properties.name.toLowerCase()&& x.reportYear ===reportYear);
      if(filter.length>0)
      {
        let sumVal:number =
        filter.map(a=>a.totalReportCount).reduce(function(a,b)
        {
          return a+b;
        });
        let requiredSum:number =
        filter.map(a=>a.requiredReportCount).reduce(function(a,b)
        {
          return a+b;
        });
        let voluntarySum:number =
        filter.map(a=>a.voluntaryReportCount).reduce(function(a,b)
        {
          return a+b;
        });
        this.graphData.push({code3:element.properties["hc-key"],name:element.properties["name"],value:sumVal,requiredCnt:requiredSum,voluntaryCnt:voluntarySum});
      }



    });
    //console.log(this.graphData);
     this.GetChartOptions();
  }



  GetChartOptions()
  {
    this.chartOptions= {
      chart: {
        map: mapWorld as any,
        width:950,
        height:600

      },
      exporting: {
        fallbackToExportServer: false
      },
      title: {
        text: "Reports Submitted By Post"
      },
      credits:{
        enabled:false
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: "spacingBox"
        }
      },
      plotOptions:{
        map:{
          color:Highcharts.getOptions().colors[3]
        }
      },
      legend: {
        enabled: true
      },
      colorAxis: {
        min: 0,
        minColor: '#E6E7E8',
        maxColor: '#005645'
      },
      tooltip: {
        backgroundColor: 'none',
        borderWidth: 0,
        shadow: false,
        useHTML: true,
        padding: 0,
        pointFormat: '<div style="border:1px solid gray;padding:10px;border-radius: 2px;box-shadow: 3px 5px 8px #888888;"> <span class="f32"><span class="flag {point.properties.hc-key}">' +
            '</span><span style="font-size:20px"> {point.name}</span></span><br>' +
            '<span style="font-size:1rem">Required - {point.requiredCnt}</span><br>'+
            '<span style="font-size:1rem">Voluntary - {point.voluntaryCnt}</span><br/>'+
            '<span style="font-size:15px">Total - {point.value}</span></div>',
        positioner: () => ({ x: 10, y: 450 })
    },
      series: [
        {
          type: "map",
          name: "Report Counts",
          states: {
            hover: {
              color: Highcharts.getOptions().colors[3],
              borderColor: 'gray'
            }
          },
          joinBy: ['hc-key', 'code3'],
          //allAreas: false,
          data: this.graphData
        }
      ]
    };
  }

}
